import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export const getAllTakhfifHayeJarimehSarneshin = createAsyncThunk(
  'TakhfifJarimehSales/GetAllTakhfifHayeJarimehSarneshin',
  async () => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.TakhfifJarimehSales.GetAllTakhfifHayeJarimehSarneshin}`,
    });
  }
);
